// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"65":"7faf30ea","97":"c3cf2888","306":"d586c4b5","821":"c5b84161","858":"2d6ec4b4","966":"6f8bf728","973":"956af055"}[chunkId] + ".chunk.js";
};